module.exports = __webpack_public_path__ + "img/formal_exam_success.ee94029f.png";